import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e2a2dda&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2a2dda')) {
      api.createRecord('6e2a2dda', component.options)
    } else {
      api.reload('6e2a2dda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6e2a2dda&", function () {
      api.rerender('6e2a2dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/srm-dialog/index.vue"
export default component.exports